export default "__VITE_ASSET__fb8e0629__"